import InputBase from '@material-ui/core/InputBase';
import { withStyles } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core';

const styles = () => createStyles({});

export default withStyles(styles)(InputBase);
